import React, { useRef, useEffect, forwardRef, MutableRefObject } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import { StyledButton } from './Button.styles';

export interface ButtonProps extends SCP<'button'> {
  autofocus?: boolean;
  autoFocus?: boolean;
  tag?: string | React.ComponentType<any>;
  /** The text wraps to the next line when needed. */
  wrapText?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ autofocus, autoFocus, tag, wrapText, ...props }, ref) => {
  const buttonRef = useRef<HTMLButtonElement>();

  const resolveRef = ref || buttonRef;

  useEffect(() => {
    if (autofocus || autoFocus) {
      (resolveRef as MutableRefObject<HTMLButtonElement>)?.current.focus();
    }
  }, [autofocus, autoFocus, resolveRef]);

  return (
    <StyledButton type="button" ref={resolveRef} as={tag} $wrap={wrapText} {...props} />
  );
});

export default Button;
